(function () {
  class UsfCollection {
    constructor(root) {
      this.root = root;
      this.initView();
      this.initFilters();
      this.initFolds();
      this.initFiltersToggle();
      this.initAddToCart();
    }

    initFiltersToggle() {
      const btn = this.root.querySelector('[data-usf-filters-toggle]');
      const layout = this.root.querySelector('[data-usf-layout]');
      if (!btn || !layout) return;
      btn.addEventListener('click', () => {
        const open = layout.classList.toggle('is-filters-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    initView() {
      const grid = this.root.querySelector('[data-usf-grid]');
      const btns = this.root.querySelectorAll('[data-usf-view]');
      if (!grid || !btns.length) return;
      const saved = localStorage.getItem('usf-col-view');
      if (saved) this.setView(grid, btns, saved);
      btns.forEach((b) => b.addEventListener('click', () => {
        const v = b.getAttribute('data-usf-view');
        this.setView(grid, btns, v);
        localStorage.setItem('usf-col-view', v);
      }));
    }
    setView(grid, btns, v) {
      grid.setAttribute('data-usf-view', v);
      btns.forEach((b) => b.classList.toggle('is-active', b.getAttribute('data-usf-view') === v));
    }

    initFilters() {
      const form = this.root.querySelector('[data-usf-filter-form]');
      const controls = this.root.querySelectorAll('[data-usf-autosubmit]');
      controls.forEach((el) => {
        el.addEventListener('change', () => {
          const f = el.form || form;
          if (f) f.submit();
        });
      });
    }

    initFolds() {
      this.root.querySelectorAll('[data-usf-fold]').forEach((head) => {
        head.addEventListener('click', () => {
          const open = head.getAttribute('aria-expanded') === 'true';
          head.setAttribute('aria-expanded', open ? 'false' : 'true');
        });
      });
    }

    initAddToCart() {
      const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      this.root.querySelectorAll('form[data-usf-add]').forEach((form) => {
        form.addEventListener('submit', async (e) => {
          e.preventDefault();
          const btn = form.querySelector('[type="submit"]');
          if (btn && btn.disabled) return;
          if (btn) btn.disabled = true;
          try {
            const cartDrawer = document.querySelector('cart-drawer');
            const fd = new FormData(form);
            if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
              fd.append('sections', cartDrawer.getSectionsToRender().map((s) => s.id).join(','));
              fd.append('sections_url', window.location.pathname);
            }
            const res = await fetch(rootUrl + 'cart/add.js', {
              method: 'POST',
              headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
              body: fd,
            });
            const data = await res.json();
            if (data.status) { window.alert(data.description || data.message || 'Could not add to cart.'); return; }
            if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
              cartDrawer.classList.remove('is-empty');
              cartDrawer.renderContents(data);
              if (typeof cartDrawer.open === 'function') cartDrawer.open();
            } else {
              window.location = rootUrl + 'cart';
            }
          } catch (err) {
            console.error('[usf-col] add failed', err);
            window.location = rootUrl + 'cart';
          } finally {
            if (btn) btn.disabled = false;
          }
        });
      });
    }
  }

  function init() {
    document.querySelectorAll('.usf-col').forEach((el) => {
      if (!el.dataset.usfColInit) { el.dataset.usfColInit = '1'; new UsfCollection(el); }
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
